
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 15.773L7.79 14.68a161.68 161.68 0 01-3.009-2.774 37.288 37.288 0 01-2.11-2.226C1.918 8.794 1.397 8 1.11 7.297A6.042 6.042 0 01.68 5.07c0-1.276.43-2.356 1.29-3.242C2.854.943 3.948.5 5.25.5 6.76.5 8.01 1.086 9 2.258 9.99 1.086 11.24.5 12.75.5c1.302 0 2.383.443 3.242 1.328.886.886 1.328 1.966 1.328 3.242 0 1.016-.338 2.07-1.015 3.164a15.681 15.681 0 01-2.227 2.852c-.781.807-2.07 2.018-3.867 3.633L9 15.773z","fill":"currentColor"}})])
          )
        }
      }
    